import { render, staticRenderFns } from "./PContentPlaceholder.vue?vue&type=template&id=7acfafc3&scoped=true"
import script from "./PContentPlaceholder.vue?vue&type=script&lang=js"
export * from "./PContentPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./PContentPlaceholder.vue?vue&type=style&index=0&id=7acfafc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acfafc3",
  null
  
)

export default component.exports